<div #container (swipeleft)="goLeft()" (swiperight)="goRight()" class="container">
  <div #box1 class="box1">
    <ng-template (attached)="onComponentRendering($event)" [cdkPortalOutlet]="box1component"></ng-template>


  </div>
  <div #box2 class="box2">
    <ng-template (attached)="onComponent2Rendering($event)" [cdkPortalOutlet]="box2component"></ng-template>

  </div>
</div>
<div #third></div>
